/** Point d'entrée du front : montage de React et du routeur. */

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';

import './index.css';
import { SessionProvider } from './hooks/useSession';
import { router } from './router';

const container = document.getElementById('root');
if (!container) {
  throw new Error("L'élément racine #root est absent de la page.");
}

createRoot(container).render(
  <StrictMode>
    <SessionProvider>
      <RouterProvider router={router} />
    </SessionProvider>
  </StrictMode>,
);
